import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Login} from '../model/Login';
import {AuthenticationService} from '../../shared/Services/authentication.service';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Role} from '../../shared/Models/Role';
import {ReCaptchaV3Service} from 'ng-recaptcha';
import {Helper} from '../../helpers/helper.service';
import {StorageService} from '../storage.service';

@Component({
  selector: 'app-login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.scss']
})
export class LoginModalComponent implements OnInit {
  public login: Login = new Login();
  public isSubmitting = false;
  public twoFactorStep = false;
  @Output() afterLogin = new EventEmitter();

  constructor(private auth: AuthenticationService,
              private router: Router,
              private translateService: TranslateService,
              private reCaptchaV3Service: ReCaptchaV3Service,
              private helper: Helper,
              private storageService: StorageService
  ) {
  }

  ngOnInit() {
    if (this.auth.isLoggedIn()) {
      this.auth.getProfile().subscribe((result) => {
        this.login.username = result.username;
      });
    }
  }

  submitLogin() {
    this.isSubmitting = true;
    this.reCaptchaV3Service.execute('login').subscribe((token: string) => {
      this.login.recaptchaToken = token;
      this.storageService.setData(this.login);
      this.auth.login(this.login).subscribe((result) => {
        this.isSubmitting = false;
        if ( result['2faIsActivated']) {
          this.twoFactorStep = true;
        } else {
            this.login.username = result.username;
            this.twoFactorStep = false;
            delete this.login.password;
            delete this.login.plainPassword;
            delete this.login.auth_code;
            this.afterLogin.emit(result);
        }
      }, () => {
        this.isSubmitting = false;
      });
    }, () => {
      this.isSubmitting = false;
      this.helper.popMessageDialog(
        this.translateService.instant('errors.recaptcha.title'),
        this.translateService.instant('errors.recaptcha.failed'),
        'error',
        false,
      );
    });
  }
}
